const type = 'STATEMENTS_DONE_SCROLLING';

const statementsDoneScrolling = () => ({
  type,
});

export { type };
export default statementsDoneScrolling;
